import { render, staticRenderFns } from "./BuscarMedicamento.vue?vue&type=template&id=0cb07241&scoped=true"
import script from "./BuscarMedicamento.vue?vue&type=script&lang=js"
export * from "./BuscarMedicamento.vue?vue&type=script&lang=js"
import style0 from "./BuscarMedicamento.vue?vue&type=style&index=0&id=0cb07241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb07241",
  null
  
)

export default component.exports